<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.chosen_edit") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-select-input
            col="6"
            :optionsList="selection_priorities"
            :placeholder="$t('PLACEHOLDERS.selection_priority')"
            v-model="data.selection_priority"
            required
          />
          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";

export default {
  name: "EditAds",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      data: {
        work_hours: [
          {
            // id : null,
            day_id: { id: null, name: null },
            start_time: null,
            end_time: null,
            // created_at:null
          },
        ],
        dayMappingToEnglish: {
          الأحد: "Sunday",
          الاثنين: "Monday",
          الثلاثاء: "Tuesday",
          الأربعاء: "Wednesday",
          الخميس: "Thursday",
          الجمعة: "Friday",
          السبت: "Saturday",
        },
        logo: { path: "", file: "" },
        commercial_register_image: { path: "", file: "" },
        commercial_register: "",
        name: "",
        store_name_ar: "",
        store_name_fr: "",
        mobile: "",
        email: "",
        provider: null,
        passwordConfirmation: "",
        description_ar: "",
        description_fr: "",
        preparation_time: "",
        store_category: null,
        latitude: 18.0735,
        longitude: -15.9582,
        area: "",
        selection_priority: null,
        city: "",
        district: "",
        street: "",
        building: "",
        bank_name: "",
        bank_account: "",
        iban: "",
        address: "",
      },
      imgUrls: [],
      store_categories: [],
      providers: [],
      banks: [],

      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    selection_priorities() {
      return [
        { id: 1, name: 1, value: 1 },
        { id: 2, name: 2, value: 2 },
        { id: 3, name: 3, value: 3 },
        { id: 4, name: 4, value: 4 },
        { id: 5, name: 5, value: 5 },
        { id: 6, name: 6, value: 6 },
        { id: 7, name: 7, value: 7 },
        { id: 8, name: 8, value: 8 },
        { id: 9, name: 9, value: 9 },
        { id: 10, name: 10, value: 10 },
      ];
    },
    types() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.flat"),
          value: "flat",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.percentage"),
          value: "percentage",
        },
      ];
    },
  },

  methods: {
    selectImage1(selectedImage1) {
      this.data.commercial_register_image = selectedImage1;
    },
    selectImage2(selectedImage2) {
      this.data.tax_file = selectedImage2;
    },
    selectImage3(selectedImag3) {
      this.data.license = selectedImag3;
    },

    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("provider_id", this.$route.params.id);
      if (this.data.selection_priority) {
        REQUEST_DATA.append(
          "selection_priority",
          this.data.selection_priority?.value
        );
      }
      REQUEST_DATA.append("_method", "PUT");

      try {
        await this.$axios({
          method: "POST",
          url: `selected-providers/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("PLACEHOLDERS.chanchedSuccessfully"));
        this.$router.push({ path: "/chosen/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
    async getProviders() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers?selected=0`,
          params: {
            is_active: 1,
            page: 0,
            limit: 0,
          },
        });
        this.providers = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // start all ads data
    async getAdsData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `selected-providers/${this.$route.params.id}`,
        });

        console.log("Cjose", res);

        this.data.selection_priority = {
          id: res.data.data.selection_priority,
          name: res.data.data.selection_priority,
          value: res.data.data.selection_priority,
        };
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end all ads data
  },

  created() {
    // Start:: Fire Methods
    this.getAdsData();
    // End:: Fire Methods
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
}
</style>
